/** Normalize department / designation for comparison (spaces, underscores, hyphens). */
export const normalizeRoleKey = (value?: string | null): string =>
	String(value || '')
		.trim()
		.toUpperCase()
		.replace(/[\s-]+/g, '_');

/** SERVICE department + TEAM MEMBER / TEAM_MEMBER → technician portal */
export const isServiceTeamMember = (user?: {
	department?: string | null;
	designation?: string | null;
} | null): boolean => {
	if (!user) return false;
	const department = normalizeRoleKey(user.department);
	const designation = normalizeRoleKey(user.designation);
	return department === 'SERVICE' && designation === 'TEAM_MEMBER';
};
